import { StaticImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import { Container, Visible } from "react-grid-system"
import { COMPANIES } from "./constants"
import MapDetail from "./MapDetail"
import MapDetailMobile from "./MapDetailMobile"
import { Fade } from "react-reveal"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"

const StyledClickCallout = styled.p`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 0.9em;
  line-height: 1.3;

  color: #0f6497;
  margin: 0;

  ${breakpoint.sm} {
    font-size: 1.05em;
  }

  ${breakpoint.md} {
    font-size: 1.2em;
  }
`

const StyledClickCallOutWrapper = styled.div`
  text-align: right;
  margin-top: 20px;
  margin-bottom: ${props => (props.isMarginBottom ? `50px` : `0px`)};
`

const MapDetailWrapper = styled.div`
  border-top: 3px solid #0f6494;
  border-bottom: 3px solid #0f6494;
  padding-top: 5%;
  padding-bottom: 5%;
  margin-top: 8%;
  margin-bottom: 0;

  ${breakpoint.lg} {
    border-top: 5px solid #0f6494;
    border-bottom: 5px solid #0f6494;
    padding-top: 55px;
    padding-bottom: 55px;
    margin-top: 60px;
    margin-bottom: 60px;
  }
`

// 960 x 544 = 1.764705882

const Map = () => {
  const [currentlySelectedCompany, setCurrentlySelectedCompany] = useState("")

  const handleSelectCompany = company => {
    setCurrentlySelectedCompany(company)
  }

  return (
    <>
      <Container fluid xs sm md>
        <Fade ssrReveal>
          <div style={{ width: "100%", position: "relative" }}>
            <StaticImage
              src="../../images/map.png"
              alt="world map"
              layout="fullWidth"
            />
            <div
              role="button"
              style={{
                cursor: "pointer",
                width: "12%",
                height: "13%",
                position: "absolute",
                top: "51%",
                left: "43.7%",
              }}
              onClick={() => handleSelectCompany(COMPANIES.cropIn)}
            ></div>
            <div
              role="button"
              style={{
                cursor: "pointer",
                width: "15.5%",
                height: "12.2%",
                position: "absolute",
                top: "66.7%",
                left: "47.7%",
              }}
              onClick={() => handleSelectCompany(COMPANIES.sunseap)}
            ></div>
            <div
              role="button"
              style={{
                cursor: "pointer",
                width: "13%",
                height: "12.2%",
                position: "absolute",
                top: "80%",
                left: "59%",
              }}
              onClick={() => handleSelectCompany(COMPANIES.v2Food)}
            ></div>
            <div
              role="button"
              style={{
                cursor: "pointer",
                width: "12%",
                height: "18.5%",
                position: "absolute",
                top: "53.9%",
                left: "81%",
              }}
              onClick={() => handleSelectCompany(COMPANIES.kimDental)}
            ></div>
            <div
              role="button"
              style={{
                cursor: "pointer",
                width: "16%",
                height: "12%",
                position: "absolute",
                top: "40%",
                left: "83.5%",
              }}
              onClick={() => handleSelectCompany(COMPANIES.cdFinance)}
            ></div>
          </div>
          <StyledClickCallOutWrapper
            isMarginBottom={!Boolean(currentlySelectedCompany)}
          >
            <StyledClickCallout>
              *Click on the different companies to find out more
            </StyledClickCallout>
          </StyledClickCallOutWrapper>
        </Fade>
      </Container>
      {currentlySelectedCompany ? (
        <MapDetailWrapper>
          <Container fluid xs sm md>
            <Visible xs sm md>
              {currentlySelectedCompany ? (
                <Fade ssrReveal>
                  <MapDetailMobile
                    currentlySelectedCompany={currentlySelectedCompany}
                  />
                </Fade>
              ) : null}
            </Visible>
            <Visible lg xl xxl>
              {currentlySelectedCompany ? (
                <Fade ssrReveal>
                  <MapDetail
                    currentlySelectedCompany={currentlySelectedCompany}
                  />
                </Fade>
              ) : null}
            </Visible>
          </Container>
        </MapDetailWrapper>
      ) : null}
    </>
  )
}

export default Map
